import { useState, useEffect, useContext } from "react";
import GoogleMap from "../components/features/maps/components/GoogleMapView";
import GridLayoutDisplay from "../components/features/properties/components/display/PropertyGrid";
import axios from "axios";
import Cookies from "js-cookie";
import { MyContextMapAndGrid } from "../App";
import Swal from "sweetalert2";
import useEffectOnce from "../components/shared/hooks/useEffectOnce";
// import Snowfall from "react-snowfall";

const Home = () => {
  const token = Cookies.get("jwt");

  const handleImageError = (e, fallback = "/bg-login.jpg") => {
    e.target.src = fallback;
    e.target.onerror = null;
  };


  
  // this is googel map modal detail & grid modal detail
  const [isExpanded, setIsExpanded] = useState(false);
  const [heightStep, setHeightStep] = useState('half');
  const [mainDataModal, setMainDataModal] = useState(null);

  // this is googel map modal detail & grid modal detail
  

  useEffectOnce(()=>{
    axios.post(`${process.env.REACT_APP_ADMIN_API}/event/count-viewer`,{

    }).then((res)=>{
      console.log(res.data)
    }).catch((err)=>{
      console.log(err)
    })
  })
  const statusFirstComeReqLocation = localStorage.getItem(
    "notificationReqLocationFirstCome"
  );  

  // If the key doesn't exist in localStorage, it's the user's first visit
  const isFirstVisit = statusFirstComeReqLocation === null;

  // Set the modal's initial status based on whether it's the user's first visit
  const [isModalReqLocationFirstCome, setIsModalReqLocationFirstCome] =
    useState(isFirstVisit);

  const statusInSessionCloseMap = sessionStorage.getItem("statusCloseMap");

  const tempURLProductForBackwardAfterLoginOrRegister = sessionStorage.getItem(
    "tempURLProductForBackwardAfterLoginOrRegister"
  );
  useEffect(() => {
    if (tempURLProductForBackwardAfterLoginOrRegister !== null) {
      window.location.replace(tempURLProductForBackwardAfterLoginOrRegister);
      sessionStorage.removeItem(
        "tempURLProductForBackwardAfterLoginOrRegister"
      );
    }
  }, []);

  const {
    statusCloseMap,
    SetStatusCloseMap,
    statusCloseGrid,
    setStatusCloseGrid,
    statusHalfGridMap,
    setStatusHalfGridMap,
    isFullMapButtonOn,
    setIsFullMapButtonOn,
    isFullGridButtonOn,
    setIsFullGridButtonOn,
    searchValue,
    setSearchValue,
    dataSearchValue,
    setDataSearchValue,
    dataDisplay,
    setDataDisplay,

  } = useContext(MyContextMapAndGrid);

  const [hideScreenMobile, setHideScreenMobile] = useState(false);

  const changeStatusMap = () => {
    setStatusHalfGridMap(!statusHalfGridMap);
    setStatusCloseGrid(!statusCloseGrid);
    setIsFullMapButtonOn(!isFullMapButtonOn);
  };

  const changeStatusGrid = () => {
    setStatusHalfGridMap(!statusHalfGridMap);
    SetStatusCloseMap(!statusCloseMap);
    setIsFullGridButtonOn(!isFullGridButtonOn);
  };

  const getCookie = () => {
    const session_id = Cookies.get("jwt");
    return session_id;
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_API}/user/getDataProfile`, {
        headers: {
          Authorization: `Bearer ${getCookie()}`,
        },
      })
      .then((response) => {
        // console.log(response.data);
      })
      .catch((error) => {
        // console.log(error);
      });
  }, []);

  useEffect(() => {
    const checkSizeScreen = () => {
      setHideScreenMobile(window.innerWidth <= 820);
    };

    // Call the function immediately on component mount
    checkSizeScreen();

    // Setup the event listener
    window.addEventListener("resize", checkSizeScreen);

    // Cleanup the event listener on component unmount
    return () => window.removeEventListener("resize", checkSizeScreen);
  }, []);

  
  const [isSearching, setIsSearching] = useState(false);

  useEffect(() => {
    if (searchValue === "") {
      // reset search value so displayData can map data again
      setDataSearchValue([]);
      setIsSearching(false);
      return;
    }

    // ต้อง encode ก่อน เพราะคีย์เวิร์ดไปอยู่ใน path ตรง ๆ อักขระอย่าง ? # /
    // จะทำให้ URL เพี้ยนและได้ 404 กลับมา
    let cancelled = false;
    setIsSearching(true);

    axios
      .get(`${process.env.REACT_APP_API}/event/search/${encodeURIComponent(searchValue)}`)
      .then((res) => {
        if (!cancelled) setDataSearchValue(res.data.assets || []);
      })
      .catch(() => {
        // ค้นหาไม่สำเร็จ ให้แสดงว่าไม่พบ ดีกว่าค้างผลลัพธ์ชุดเดิมไว้
        if (!cancelled) setDataSearchValue([]);
      })
      .finally(() => {
        if (!cancelled) setIsSearching(false);
      });

    return () => {
      cancelled = true;
    };
  }, [searchValue]);

  const panToUserLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          };

          // console.log(pos)
          localStorage.setItem("LatForRecommendedAssets", pos.lat);
          localStorage.setItem("LngForRecommendedAssets", pos.lng);
          // setCurrentLocation(pos);
          Swal.fire("ขอตำแหน่งสำเร็จ", "", "success");
        },
        (positionError) => {},
        { enableHighAccuracy: true }
      );
    }
  };

  function handleNotificationReqLocation(status) {
    if (status === "approved") {
      panToUserLocation();
      localStorage.setItem("notificationReqLocationFirstCome", "false");
    }
    setIsModalReqLocationFirstCome(false);
  }


  // Map column class
  const mapColClass = statusCloseMap
    ? "hidden"
    : statusCloseGrid
    ? "w-full h-full"
    : "w-full lg:w-[62%] h-full flex-shrink-0";

  // Grid column class
  const gridColClass = statusCloseGrid
    ? "hidden"
    : statusCloseMap
    ? "w-full h-full overflow-y-auto"
    : "hidden lg:block lg:w-[38%] h-full overflow-y-auto flex-shrink-0";

  return (
    <div className="w-full h-screen overflow-hidden">
      <div className="flex h-full  lg:pt-20">

        {/* ── MAP PANEL ── */}
        <div className={mapColClass}>
          <GoogleMap
            statusInSessionCloseMap={statusInSessionCloseMap}
            setDataSearchValue={setDataSearchValue}
            setSearchValue={setSearchValue}
            statusHalfGridMap={statusHalfGridMap}
            setStatusHalfGridMap={setStatusHalfGridMap}
            statusCloseMap={statusCloseMap}
            SetStatusCloseMap={SetStatusCloseMap}
            isFullGridButtonOn={isFullGridButtonOn}
            setIsFullGridButtonOn={setIsFullGridButtonOn}
            setDataDisplay={setDataDisplay}
            setIsExpanded={setIsExpanded}
            isExpanded={isExpanded}
            setHeightStep={setHeightStep}
            heightStep={heightStep}
            mainDataModal={mainDataModal}
            setMainDataModal={setMainDataModal}
          />
        </div>

        {/* ── GRID PANEL ── */}
        <div className={gridColClass}>
          <GridLayoutDisplay
            statusCloseMap={statusCloseMap}
            statusHalfGridMap={statusHalfGridMap}
            setStatusHalfGridMap={setStatusHalfGridMap}
            SetStatusCloseMap={SetStatusCloseMap}
            dataSearchValue={dataSearchValue}
            setSearchValue={setSearchValue}
            isSearching={isSearching}
            dataDisplay={dataDisplay}
            setDataDisplay={setDataDisplay}
            setHeightStep={setHeightStep}
            heightStep={heightStep}
            mainDataModal={mainDataModal}
            setMainDataModal={setMainDataModal}
          />
        </div>
      </div>

      {/* ── Location Permission Modal ── */}
      {isModalReqLocationFirstCome && (
        <>
          <div
            className="fixed inset-0 bg-black/40 z-[140] backdrop-blur-sm"
            onClick={() => setIsModalReqLocationFirstCome(false)}
          />
          <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-11/12 max-w-sm bg-white rounded-2xl shadow-2xl z-[150] p-6">
            <h2 className="font-bold text-center text-xl mb-3">แจ้งเตือน</h2>
            <p className="text-sm text-gray-600 text-center leading-relaxed">
              เพื่อประสบการณ์ใช้งานที่ดียิ่งขึ้น ทีม Postperty ขอใช้ตำแหน่งของคุณเพื่อแนะนำทรัพย์บริเวณใกล้เคียง
            </p>
            <div className="flex gap-3 mt-6">
              <button
                className="flex-1 h-11 border border-gray-200 rounded-full text-gray-600 hover:bg-gray-50 transition-colors text-sm font-medium"
                onClick={() => handleNotificationReqLocation("failed")}
              >
                ภายหลัง
              </button>
              <button
                className="flex-1 h-11 bg-postperty-linear-light text-white rounded-full hover:opacity-90 transition-opacity text-sm font-medium"
                onClick={() => handleNotificationReqLocation("approved")}
              >
                อนุญาต
              </button>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default Home;
